module.exports = __webpack_public_path__ + "tempal-icons.92b9ec125bd630cc24c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/tempal-icons/tempal-icons.svg?c8otwj
// module id = 393
// module chunks = 5